import { pickLocale } from './locale'

const en = {
  hero: {
    scroll: 'How it works',
  },
  howItWorks: {
    kicker: 'How it works',
    title: 'Three steps.',
    steps: [
      {
        title: 'Write your wishes',
        text: 'Your music, your clothes, what to do with your body, that one letter you keep postponing, and more...',
      },
      {
        title: 'Pick your people',
        text: 'Family, friends, lovers or even slightly strangers. Connect directly or add the contacts that matter to you.',
      },
      {
        title: "Live. We'll wait.",
        text: 'Everything stays sealed until it is time. Not one minute before.',
      },
    ],
  },
  showcase: {
    kicker: 'The app',
    title: 'A place that looks like you.',
    slides: [
      { img: '/showcase/app-2-en.jpg', caption: 'Leave words that stay.' },
      { img: '/showcase/app-1-en.jpg', caption: 'Let others know your wishes.' },
      { img: '/showcase/app-3-en.jpg', caption: 'Keep your secrets, revealed when needed.' },
    ],
  },
  objections: {
    kicker: 'Fair questions',
    title: 'Things people ask before downloading.',
    items: [
      {
        q: "Isn't this a bit morbid?",
        a: 'A little. Yet it matters. The best thing you can do is talk about it directly with your circle.',
      },
      {
        q: 'Is it complicated?',
        a: 'It was built to make all of this simple. And we stay open to every bit of feedback.',
      },
      {
        q: 'What if I never need it?',
        a: 'Then congratulations on the immortality. Please write to us, we have questions.',
      },
      {
        q: 'Do I have to pay?',
        a: 'No. As long as we can, it stays free. The other plans exist for people who need a bit more, and they help cover the infrastructure costs.',
      },
    ],
  },
  nav: {
    getApp: 'Get the app',
  },
}

const fr = {
  hero: {
    scroll: 'Comment ça marche',
  },
  howItWorks: {
    kicker: 'Comment ça marche',
    title: 'Trois étapes.',
    steps: [
      {
        title: 'Écrivez vos souhaits',
        text: "Votre musique, vos vêtements, ce qu'on fait de votre corps, cette lettre que vous repoussez depuis des années, et plus encore...",
      },
      {
        title: 'Choisissez vos gens',
        text: 'Famille, amis, amours ou même de vagues connaissances. Connectez-vous directement ou ajoutez les contacts qui comptent pour vous.',
      },
      {
        title: 'Vivez. On attend.',
        text: "Tout reste scellé jusqu'au moment venu. Pas une minute avant.",
      },
    ],
  },
  showcase: {
    kicker: "L'app",
    title: 'Un endroit qui vous ressemble.',
    slides: [
      { img: '/showcase/app-2-fr.jpg', caption: 'Laissez des mots qui restent.' },
      { img: '/showcase/app-1-fr.jpg', caption: 'Faites connaître vos souhaits.' },
      { img: '/showcase/app-3-fr.jpg', caption: 'Gardez vos secrets, révélés le moment venu.' },
    ],
  },
  objections: {
    kicker: 'Questions légitimes',
    title: "Ce qu'on nous demande avant de télécharger.",
    items: [
      {
        q: "C'est pas un peu morbide ?",
        a: "Un peu. Mais c'est un sujet qui compte. Le mieux reste d'en parler directement avec votre entourage.",
      },
      {
        q: "C'est compliqué ?",
        a: "Tout a été pensé pour rester simple. Et on reste à l'écoute de tous vos retours.",
      },
      {
        q: "Et si je n'en ai jamais besoin ?",
        a: "Alors félicitations, l'immortalité vous va bien. Écrivez-nous, on a des questions.",
      },
      {
        q: 'Faut-il payer ?',
        a: "Non. Tant qu'on le peut, ça reste gratuit. Les autres offres existent pour ceux qui ont besoin d'un peu plus, et elles aident à payer l'infrastructure.",
      },
    ],
  },
  nav: {
    getApp: "Télécharger l'app",
  },
}

export function getHomeContent(language) {
  return pickLocale({ en, fr }, language)
}
